import { useMutation } from '@tanstack/react-query'

import { notification } from '../../genericComponents/Notification'
import { ChangePasswordDto, UserRegistrationControllerService } from '../../generated'

export const useAckTermsAndConditions = () =>
  useMutation({
    mutationFn: () => UserRegistrationControllerService.ackTermsAndConditions(),

    onError: (error) => {
      notification.error(error)
    },
    onSuccess: () => {
      notification.success('Terms acceptance saved')
    },
  })

export const useChangePasswordRegistration = () =>
  useMutation({
    mutationFn: (requestBody: ChangePasswordDto) =>
      UserRegistrationControllerService.changePassword({ requestBody }),

    onError: () => {
      notification.CustomError('Failure', 'Password change failed.')
    },
    onSuccess: () => {
      notification.success('Password changed successfully')
    },
  })
